'use client'

import { Spacer, Text } from '@vinted/web-ui'

import { AppStoreButtons } from '@marketplace-web/domain/web-to-app'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const AboutAppBanner = () => {
  const translate = useTranslate('about_mission.download')

  return (
    <>
      <Spacer size={Spacer.Size.X4Large} />
      <div className="u-tablets-up-only">
        <Spacer size={Spacer.Size.X4Large} />
      </div>
      <div className="u-phones-only">
        <div className="about__section">
          <Text as="h3" alignment={Text.Alignment.Left} type={Text.Type.HeadingXXL}>
            {translate('title')}
          </Text>
          <Text as="p" alignment={Text.Alignment.Left} type={Text.Type.Body}>
            {translate('text')}
          </Text>
          <Spacer size={Spacer.Size.X2Large} />
          <AppStoreButtons />
        </div>
        <Spacer size={Spacer.Size.X4Large} />
      </div>
    </>
  )
}

export default AboutAppBanner
